import { z } from "zod";

// Recursive NavigationLink type
export interface NavigationLink {
  name: string;
  summary: string;
  pageid: string; // Optional pageId for linking to specific pages
  tooltip: string;
  openinnewwindow: boolean;
  url: string;
  image: string;
  imagetype: string;
  imageonly: boolean;
  imageheight: number;
  imagewidth: number;
  imagealt: string;
  sublinks: NavigationLink[];
}

export interface NavigationMenu {
  status: string;
  statuscode: number;
  id: string;
  name: string;
  results: NavigationLink[];
}

// Zod schema for NavigationLink (recursive)
export const NavigationLinkSchema: z.ZodType<NavigationLink> = z.lazy(() =>
  z.object({
    name: z.string(),
    summary: z.string(),
    tooltip: z.string(),
    pageid: z.string(), 
    openinnewwindow: z.boolean(),
    url: z.string(),
    image: z.string(),
    imagetype: z.string(),
    imageonly: z.boolean(),
    imageheight: z.number(),
    imagewidth: z.number(),
    imagealt: z.string(),
    sublinks: z.array(NavigationLinkSchema),
  })
);

export const NavigationMenuSchema = z.object({
  status: z.string(),
  statuscode: z.number(),
  id: z.string(),
  name: z.string(),
  results: z.array(NavigationLinkSchema),
});
